module.exports = __webpack_public_path__ + "media/images/redesign-images/graduate-program/grad-01-bea073db94d35e891388e150d9187b07.webp";